import {ActivationStatusType, ActivationStatusTypeDisplay} from "../formability/admin/models/activationStatusType";

export function userActivationStatusDisplay(user, showStatusOnly: boolean = false, showActive: boolean = false): string {
  // shows only status
  if (showStatusOnly) {
    if (showActive && user.activation_status === ActivationStatusType.active) {
      return `(${ActivationStatusTypeDisplay[ActivationStatusType.active]})`
    } else if (user.activation_status === ActivationStatusType.inactive) {
      return `(${ActivationStatusTypeDisplay[ActivationStatusType.inactive]})`
    } else {
      return ''
    }
  }

  // shows name with status
  let name: string;
  if (user.name) {
    name = user.name
  } else if (user.first_name && user.last_name) {
    name = `${user.first_name} ${user.last_name}`
  }

  if (showActive && user.activation_status === ActivationStatusType.active) {
    return `${name} (${ActivationStatusTypeDisplay[ActivationStatusType.active]})`
  } else if (user.activation_status === ActivationStatusType.inactive) {
    return `${name} (${ActivationStatusTypeDisplay[ActivationStatusType.inactive]})`
  } else {
    return name
  }
}